import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { isStrEmpty } from '@eforms/forms-common-ui';
import GenericForm from "./components/GenericForm";
import './App.css'
import viewportDetection from '@zambezi/layout-grid'
import { IAMAuthenticationProvider } from './components/Authentication/IAMAuthentication';
import { ErrorScreen } from './components/utils/CustomErrorScreen';
import { SESSION_STORAGE_KEY_ID_TOKEN } from './utils/authUtils';
import { extractQueryParameterFromURL } from './utils/getQueryParamFromURL';

function App () {
  viewportDetection();

  useEffect(() => {
    const idToken = extractQueryParameterFromURL('id_token');
    const formId = extractQueryParameterFromURL('state');
    if (idToken !== null && !isStrEmpty(formId)) {
      sessionStorage.setItem(SESSION_STORAGE_KEY_ID_TOKEN, idToken);
      window.location.hash = `/form/${formId}`;
    }
  }, []);

  return (
    <div className='App'>
      <Switch>
        <Route
          path='/form/:uuid'
          render={(props) => (
            <IAMAuthenticationProvider {...props}>
              <GenericForm {...props}/>
            </IAMAuthenticationProvider>
          )}
          exact
        />
        <Route render={() => <ErrorScreen />} />
      </Switch>
    </div>
  )
}

export default App